<template>
  <div class="title" @click="go">
    <div class="title-container">
      <div class="title-flag">&nbsp;</div>
      <div class="title-label">{{title}}</div>
      <div class="title-more">
        查看更多
        <i class="iconfont icon-jiantou"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    link: String,
    token: String
  },
  methods: {
    go() {
      this.$router.push("/" + this.link + "/" + this.token);
    }
  }
};
</script>


<style scoped>
.title {
  font-size: 16px;
}
.title-container {
  display: flex;
  align-items: center;
  padding: 10px 10px 8px 10px;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
}
.title-flag {
  width: 6px;
  margin-right: 5px;
  background-color: #0a8cd7;
  border-radius: 3px;
}
.title-label {
  flex: 1;
  margin-left: 5px;
  font-weight: bold;
  color: #363437;
}
.title-more {
  text-align: right;
  font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// src/components/common/BlockTitle.vue